import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { SignIn, SignUp } from '@clerk/clerk-react';
import './auth.css';
import { SIGNING_DAY } from '../config/signingDay';

const LOGO_URL = '/twlogo-portrait.png';
const V = '1'; // bust cached asset 404s
// Until Signing Day, everyone goes straight to their room. After, sign-in lands in the Arena.
const PRE_LAUNCH = SIGNING_DAY.getTime() > Date.now();
const SIGNIN_DEST = PRE_LAUNCH ? '/practice' : '/feed';

// Dark theme for Clerk's prebuilt components — card made transparent so it blends
// into the glass panel over the check-in video.
const clerkAppearance = {
    variables: {
        colorPrimary: '#a855f7',
        colorBackground: 'transparent',
        colorText: '#ffffff',
        colorTextSecondary: '#a1a1aa',
        colorInputBackground: 'rgba(21,21,28,0.85)',
        colorInputText: '#ffffff',
        borderRadius: '0.5rem',
    },
    elements: {
        rootBox: 'mx-auto w-full',
        card: 'bg-transparent border-0 shadow-none p-0',
        headerTitle: 'hidden',
        headerSubtitle: 'hidden',
        socialButtonsBlockButton: 'border-white/15 text-white',
        footerActionLink: 'text-primary hover:text-primary',
        footer: 'text-zinc-400',
    },
};

const AuthShell = ({ kicker, title, subtitle, children }) => {
    const [playing, setPlaying] = useState(false);
    return (
        <div className="auth-stage">
            <div className="auth-bg" style={{ backgroundImage: `url(/checkin-poster.jpg?v=${V})` }}>
                <video className={`auth-video ${playing ? 'playing' : ''}`} autoPlay muted loop playsInline
                    preload="auto" aria-hidden="true" onPlaying={() => setPlaying(true)}>
                    <source src={`/checkin.mp4?v=${V}`} type="video/mp4" />
                </video>
            </div>
            <div className="auth-scrim" />

            <div className="auth-panel">
                <div className="auth-kicker"><span className="dot" /> Self-Service Check-In</div>
                <Link to="/"><img src={LOGO_URL} alt="TrapWorld" className="auth-logo" /></Link>
                <div className="auth-title">{title}</div>
                <div className="auth-sub">{subtitle}</div>
                <div className="flex justify-center">{children}</div>
            </div>
        </div>
    );
};

export const LoginPage = () => (
    <AuthShell kicker title="WELCOME BACK" subtitle="Check in and step into the Arena.">
        <SignIn routing="hash" signUpUrl="/register" forceRedirectUrl={SIGNIN_DEST} appearance={clerkAppearance} />
    </AuthShell>
);

export const RegisterPage = () => (
    <AuthShell kicker title="CHECK IN" subtitle="Claim your spot for Signing Day — all costs covered.">
        <SignUp routing="hash" signInUrl="/login" forceRedirectUrl="/practice" appearance={clerkAppearance} />
    </AuthShell>
);

// Clerk handles OAuth callbacks inside the SignIn/SignUp components (hash routing).
export const AuthCallback = () => <Navigate to="/feed" replace />;

export default LoginPage;
